import { format } from "date-fns";
import { es } from "date-fns/locale";

const escapeICS = (text) =>
  text
    .replace(/\\n/g, "\\n")
    .replace(/,/g, "\\,")
    .replace(/;/g, "\\;")
    .replace(/\n/g, "\\n");

const AddToCalendarButton = ({ ticket }) => {

  const handleAddToCalendar = () => {
    const startDate = new Date(ticket.instance.startUtc);
    const endDate = ticket.instance.end
      ? new Date(ticket.instance.endUtc)
      : new Date(ticket.instance.startUtc);

    const formatToICS = (date) => format(date, "yyyyMMdd'T'HHmmss'Z'");

    //construct description with event name and venue
    const description = `We're looking forward to welcoming you to ${ticket.instance.event.name} at ${ticket.instance.event.attribute_VenueForTicket} Theatre, see our FAQs and information about your visit here: https://www.capitaltheatres.com/faqs/`;

    const icsLines = [
      "BEGIN:VCALENDAR",
      "VERSION:2.0",
      "PRODID:-//CapitalTheatres//EN",
      "BEGIN:VEVENT",
      `UID:${Date.now()}@CapitalTheatres`, // Unique identifier for the event
      `TZID:Europe/London`, // Adjust timezone as needed
      `X-WR-TIMEZONE:Europe/London`, // Adjust timezone as needed
      `DTSTAMP:${formatToICS(new Date())}`, // Current timestamp when the event is created
      `DTSTART:${formatToICS(startDate)}`, // Start date/time in ICS format
      `SUMMARY:${escapeICS(ticket.instance.event.name)}`,
      `DESCRIPTION:${escapeICS(description)}`,
      `LOCATION:${escapeICS(ticket.instance.event.attribute_VenueForTicket + " Theatre")}`,
      `DURATION:${(() => {
        const mins = Number(ticket.instance.event.duration) > 0 ? Number(ticket.instance.event.duration) : 60;
        const hours = Math.floor(mins / 60);
        const minutes = mins % 60;
        return `PT${hours > 0 ? hours + "H" : ""}${minutes > 0 ? minutes + "M" : ""}`;
      })()}`, // Duration in ISO 8601 format (e.g., PT1H30M)
      "END:VEVENT",
      "END:VCALENDAR",
    ];

    const icsContent = icsLines.join("\r\n");

    console.log("ICS Content:", icsContent);

    const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${ticket.instance.event.name.replace(/\s+/g, "_")}.ics`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <button onClick={handleAddToCalendar} className="btn">
      Add to Calendar
    </button>
  );
};

export default AddToCalendarButton;
